import axios from "axios";
import { getCookie } from "../../getcookie.js";
const apiUrl = process.env.REACT_APP_API_URL;
const apiAccUrl = process.env.REACT_APP_ADMIN_API_URL;

const header = {
  "Content-Type": "application/json; charset=UTF-8",
  Accept: "application/json",
  "Access-Control-Allow-Origin": "*", // Required for CORS support to work
  Authorization: getCookie("mawalog"),
};

//Master List
export const getMasterApi = async (params) => {
  try {
    const response = await axios.get(apiUrl + `template` + params, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

//Group List
export const getGroupApi = async (params) => {
  try {
    const response = await axios.get(apiUrl + `template_group` + params, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

// Save Group
export const saveGroupApi = async (data) => {
  try {
    const response = await axios
      .post(apiUrl + `template_group`, data, { headers: header })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        console.log("error...", error.response);
        return error.response;
      });
    return response;
  } catch (err) {
    console.error("Error saving group:", err);
  }
};

// Update Group
export const updateGroupApi = async (data, id) => {
  try {
    const response = await axios
      .put(apiUrl + `template_group/` + id, data, { headers: header })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        console.log("error...", error.response);
        return error.response;
      });
    return response;
  } catch (err) {
    console.error("Error updating group:", err);
  }
};

// Get Group Details
export const getGroupDetailsApi = async (id) => {
  try {
    const response = await axios.get(apiUrl + `template_group/` + id, {
      headers: header,
    });
    return response.data;
  } catch (err) {
    console.error("Error fetching group details:", err);
  }
};

// Master Save
export const saveMasterApi = async (data) => {
  try {
    const response = await axios
      .post(apiUrl + `template`, data, { headers: header })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        console.log("error...", error.response);
        return error.response;
      });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

//Master Update
export const UpdateMasterApi = async (data, id) => {
  try {
    const response = await axios
      .put(apiUrl + `template/` + id, data, { headers: header })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        console.log("error...", error.response);
        return error.response;
      });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

//Master Edit
export const getMasterDetailsApi = async (id) => {
  try {
    const response = await axios.get(apiUrl + `template/` + id, {
      headers: header,
    });
    return response.data;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

//Master Delete
export const getDeleteApi = async (deleteUrl) => {
  try {
    const response = await axios.delete(apiUrl + deleteUrl, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
    return err.response;
  } finally {
  }
};
